import type { ReactNode } from 'react';

interface Props {
  id: string;
  icon: string;
  title: string;
  en: string;
  desc?: string;
  right?: ReactNode;
  children: ReactNode;
}

export default function Section({ id, icon, title, en, desc, right, children }: Props) {
  return (
    <section id={id} className="mx-auto w-full max-w-6xl scroll-mt-16 px-4 py-10 md:px-6 md:py-14">
      <div className="flex flex-wrap items-end justify-between gap-4 border-b border-background-300 pb-4">
        <div className="flex items-center gap-3">
          <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-foreground-950 text-accent-400">
            <i className={`${icon} text-lg`} />
          </span>
          <div>
            <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">{title}</h2>
            <p className="text-[11px] tracking-[0.25em] text-foreground-500 md:text-xs">{en}</p>
          </div>
        </div>
        {right}
      </div>
      {desc && <p className="mt-3 max-w-3xl text-sm leading-relaxed text-foreground-600">{desc}</p>}
      <div className="mt-6">{children}</div>
    </section>
  );
}